import { toast } from 'react-toastify';
import { OTPInput } from './OTPInput';
import { Check, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import useVerifyOTP from '../../hooks/useVerifyOTP';
import { useSendOTP } from '../../hooks/useSendOTP';
import { Controller, useForm } from 'react-hook-form';
import {
  passwordResetOTPVerification,
  requestPasswordResetOTP,
} from '../../api/authAPI';
import { useParams } from 'react-router-dom';

export default function VerifyOtp({ verified, setVerified, email }) {
  const { control, handleSubmit } = useForm();
  const [timeLeft, setTimeLeft] = useState(900);
  const redirectAfterSuccess = false;

  const { mutate: requestPasswordResetMutation } = useSendOTP(
    requestPasswordResetOTP,
    () => setTimeLeft(900)
  );

  // OTP verification mutation
  const { otpMutation, isPending } = useVerifyOTP({
    verifyFn: passwordResetOTPVerification,
    setVerified,
    redirectTo: redirectAfterSuccess ? '/login' : null,
  });

  const onSubmit = (data) => {
    if (timeLeft <= 0) {
      toast.error('OTP has expired. Please request a new one.', {
        autoClose: 3000,
        className:
          'bg-[var(--yellow-primary)] text-black text-sm px-2 py-2 rounded-md',
        closeButton: false,
      });
      return;
    }

    otpMutation({ otp: data.otp });
  };

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col justify-start gap-4 mt-6 w-full"
      aria-live="polite"
    >
      <OTPInput
        control={control}
        name="otp"
        length={4}
        onAutoSubmit={() => handleSubmit(onSubmit)()}
        verified={verified}
      />

      {!verified && (
        <div>
          {timeLeft > 0 ? (
            <div className="text-sm text-gray-600 text-center">
              OTP expires in:{' '}
              <span className="font-semibold">{formatTime(timeLeft)}</span>
            </div>
          ) : (
            <div className="text-sm text-gray-600 text-center">
              OTP expired
              <button
                type="button"
                className="font-semibold ml-2 text-blue-600 hover:underline"
                onClick={() => requestPasswordResetMutation({ email })}
              >
                Resend OTP
              </button>
            </div>
          )}
        </div>
      )}

      {verified === true && (
        <p className="text-[#68BD45] text-[15px] flex items-center gap-2">
          Code verified <Check color="#68BD45" />
        </p>
      )}
      {isPending && <p className="text-[15px]">Code verifying...</p>}
      {verified === false && (
        <p className="text-[#bd4545] text-[15px] flex items-center gap-2">
          Check code again <X color="#bd4545" />
        </p>
      )}
    </form>
  );
}
